<template>
    <confirm-dialog @confirmed="remove">
        <button-delete><i class="fa fa-trash"></i> User löschen</button-delete>
        <template slot="header">User löschen</template>
        <template slot="confirm"><button-delete><i class="fa fa-trash"></i> User löschen</button-delete></template>
        <template slot="question">Soll der Nutzer <span class="font-bold">{{ user.name }}</span> wirklich gelöscht werden?</template>
    </confirm-dialog>
</template>

<script>
import ButtonDelete from "./UI/ButtonDelete";
import ConfirmDialog from "./UI/ConfirmDialog";

export default {
    name: "UserDelete",

    components: {ConfirmDialog, ButtonDelete},

    props: ['user'],

    methods: {
        remove() {
            window.axios
                .post('/admin/users/' + this.user.id, {
                    _method: 'delete',
                })
                .then(() => {
                   window.location.href = '/admin/pages/users';
                })
                .catch((error) => {
                    this.$emit('reload');
                    this.$root.$emit('error', error);
                });

        }
    }
}
</script>

<style scoped>

</style>
